//import React from 'react';

import React, {useEffect, useState} from 'react';   
import { fetchAddresses,openModal } from '../../redux/slices/Customer/AddressesSlice';
 import {useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { placeOrder,submitPlaceOrder } from '../../redux/slices/CartSlice';
import ValidationErrors from '../Common/ValidationErrors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import AddressModal from '../User/Addresses/AddressModal';
import Loader from "../../assets/images/spinner.gif";

const  Checkout = () => {
  const {formErrors,isOrderPlaced} = useSelector((state:any) => state.cart)
  const {addresses,formModalErrors} = useSelector((state:any) => state.customerAddresses)
  const [selectedAddress,setSelectedAddress] = useState(0);
  const [errorMessage,setErrorMessage] = useState("");
  const [displayValidations, setDisplayValidations] = useState(false);
  const [displayModalValidations, setDisplayModalValidations] = useState(false);
  const {loggedInUser} = useSelector((state:any) => state.auth)
  const {cart,loading} = useSelector((state:any) => state.cart)
  const [shippingCharges, setShippingCharges] = useState(80);

  const [newAddress, setNewAddress] = useState({
    first_name: '',
    last_name: '',
    address1: '',
    address2: "",
    city: '',
    zipcode: '',
    state_id: '' as any,
    country_id: 1,
    mobile: '',
    alternate_mobile: '',
    email:''

  })


  const {states,countries} = useSelector((state:any) => state.settings);
  const dispatch = useDispatch<ThunkDispatch<any,any,any>>();
  const {cartSubtotal} = useSelector((state:any) => state.cart);
 // const handleModalClose = () => dispatch(closeModal());

  
  const handleChange = (e) => {
    const { name, value } = e.target; 
      setNewAddress((prevState) => ({
        ...prevState,
        [name]: value
      })); 
  };

  const managePlaceOrder = () => {
    submitPlaceOrder()
    if (loggedInUser !== null){
      if(selectedAddress === 0){
        setDisplayValidations(true);
        setErrorMessage("Please select address.");
      }
      else{
        setErrorMessage("");
        setDisplayValidations(false);
        const cartTotal = cartSubtotal +shippingCharges 
        dispatch(placeOrder({selectedAddress, cartTotal, newAddress,type: "withCustomer"}));
      }
    }
    if (loggedInUser === null){
      setDisplayValidations(false);
      const cartTotal = cartSubtotal +shippingCharges 
      dispatch(placeOrder({selectedAddress, cartTotal, newAddress,type: "withOutCustomer"}));
    }
    window.scrollTo(0, 0)

  };

  const manageAddAddress = () => {
    setDisplayModalValidations(false);
    dispatch(openModal());
  };

  // const manageCreateAddress = () => {
  //   setDisplayModalValidations(true);
  //   dispatch(createAddress(newAddress));
  // };

  const manageAddressSelection = (address) => {
    setSelectedAddress(address.id);
    setDisplayValidations(false);

  }

  const  roundOff = (value) => {
    return Math.round(value)
  }

  useEffect(() =>{
     loggedInUser !== null && dispatch(fetchAddresses());
  },[loggedInUser,dispatch]);

  
  useEffect(() =>{
    const calShippingCharges = () => {
      const k = cart['line_items'].length;
      const shippingCharge = 5 *( k * k) + (25 * k) + 50;
      setShippingCharges(shippingCharge);
   }
   
   if (cart && cart['line_items'] && cart['line_items'].length > 0){calShippingCharges()};
 },[cart]);


  //console.log("errors", newAddress);

  return (
    <div className="page-content bg-light">
		  <div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG">
        <div className="container">
          <div className="dz-bnr-inr-entry">
            <h1>Shop Checkout</h1>
            <nav aria-label="breadcrumb" className="breadcrumb-row">
              <ul className="breadcrumb">
                <li className="breadcrumb-item"><a href="index.html"> Home</a></li>
                <li className="breadcrumb-item">Shop Checkout</li>
              </ul>
            </nav>
          </div>
        </div>	
      </div> 
      <div className="content-inner-1">
        { loading ? <div className='pageLoader'><img src={Loader} className='loadingImg' alt="Loader"/></div> : 
        <>
          <div className="container">
          <div className="row shop-checkout">
            {loggedInUser === null && (
               <div className="col-xl-8 account-wrapper">
                <div className="row">
                 <h4 className="title m-b15">Billing details</h4>
                  { displayModalValidations && <ValidationErrors errors={formModalErrors}/>}
                  <div className="col-xl-12">
                    <ValidationErrors errors={formErrors}/>
                    <form className="row">
                      <div className="col-md-6">
                        <div className="form-group m-b25">
                          <label className="label-title">First Name</label>
                          <input name="first_name" className="form-control"  value={newAddress.first_name}   onChange={handleChange}  placeholder='First Name'/>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group m-b25">
                          <label className="label-title">Last Name</label>
                          <input name="last_name" className="form-control"  value={newAddress.last_name}   onChange={handleChange}  placeholder='Last Name'/>
                        </div>
                      </div> 
                      <div className="col-md-6">
                        <div className="form-group m-b25">
                          <label className="label-title">Mobile *</label>
                          <input name="mobile" className="form-control"  value={newAddress.mobile}   onChange={handleChange}  placeholder='Mobile'/>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group m-b25">
                          <label className="label-title">Alternate Mobile </label>
                          <input name="alternate_mobile" className="form-control"  value={newAddress.alternate_mobile}   onChange={handleChange}  placeholder='Alternate Mobile'/>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group m-b25">
                          <label className="label-title">Street address *</label> 

                          <input name="address1" className="form-control m-b15"  value={newAddress.address1}   onChange={handleChange}  placeholder='House number and street name'/>
                          <input name="address2" className="form-control"  value={newAddress.address2}   onChange={handleChange}  placeholder='Apartment, suite, unit, etc. (optional)'/>

                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="m-b25">
                          <label className="label-title">Town / City *</label>
                          <input name="city" className="form-control"  value={newAddress.city}   onChange={handleChange}  placeholder='City'/>

                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group m-b25">
                          <label className="label-title">ZIP Code *</label>
                          <input name="zipcode" className="form-control"  value={newAddress.zipcode}   onChange={handleChange}  placeholder='Zipcode'/>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="m-b25">
                          <label className="label-title">State *</label>
                          <select name="state_id" className=" form-select w-100" onChange={handleChange} value={newAddress.state_id}>
                            <option key={"001"}>Please Select</option>
                            {states.map((state) => <option key={state.id}  value={state.id}>{state.name}</option>)}
                          </select>									
                        </div>
                      </div>
                    
                      <div className="col-md-6">
                        <div className="m-b25">
                          <label className="label-title">Country / Region *</label>
                          <select name="country_id" className=" form-select w-100" onChange={handleChange} value={newAddress.country_id}>
                            {countries.map((country) => <option key={country.id}  value={country.id}>{country.name}</option>)}
                          </select>	 
                        </div>
                      </div>
                      
                      <div className="col-md-12">
                        <div className="form-group m-b25">
                          <label className="label-title">Email address *</label>
                          <input name="email" className="form-control"  value={newAddress.email}   onChange={handleChange}  placeholder='Email Address'/>
                        </div>
                      </div> 
                      
                    </form>
                  </div>
                </div>
            </div> 
            )}
             {loggedInUser !== null && (
              <div className="col-xl-8 account-wrapper">
                <div className="row">
                  <div className="col-12 m-b30">
                    <p className="m-b10">Please select the shipping address.</p>
                    <p className='errorText'>{displayValidations && <ValidationErrors errors={[errorMessage]}/>}</p>
                  </div>
                  {addresses && addresses.map((address) => 
                      <div className="col-md-6 m-b30">
                        <div className="address-card cursor-pointer" onClick={() => manageAddressSelection(address)}>
                          <div className={"account-address-box " + (selectedAddress === address.id ? 'active' : '')}>
                            <h6 className="mb-3">Address</h6>
                            <ul>
                              <li>{address.first_name} {address.last_name}</li>
                              <li>{address.address1}</li>
                              <li>{address.address2}</li>
                              <li>{address.city}, {address.state.name}, {address.country.name}, {address.zipcode}</li>
                              <li>{address.mobile}, {address.alternate_mobile}</li>
                            </ul>
                          </div>
                          <div className={"account-address-bottom "+ (selectedAddress === address.id ? 'active' : '')}>                                
                              {selectedAddress === address.id && (<FontAwesomeIcon icon={faCheckCircle} />)} {selectedAddress === address.id ?  "Selected" : ""}
                              {selectedAddress !== address.id && "Select this address"}
                          </div>
                        </div>
                      </div>
                  )} 
                  <div className="col-12">
                      <div className="account-card-add">
                          <div className="account-address-add">
                              <svg id="Line" height="50" viewBox="0 0 64 64" width="50" xmlns="http://www.w3.org/2000/svg"><path d="m59.28775 26.0578-7.30176-6.251v-11.72068a.99973.99973 0 0 0 -1-1h-7.46a.99974.99974 0 0 0 -1 1v3.60693l-7.2109-6.17675a5.07688 5.07688 0 0 0 -6.6416 0l-23.97314 20.54345a2.04251 2.04251 0 0 0 1.32226 3.56787h5.98047v18.92188a8.60569 8.60569 0 0 0 8.59082 8.60059h10.481a1.00019 1.00019 0 0 0 -.00006-2h-10.48094a6.60308 6.60308 0 0 1 -6.59082-6.60059v-19.92188a1.00005 1.00005 0 0 0 -1-1l-6.99951-.05078 23.97119-20.542a3.08781 3.08781 0 0 1 4.03955 0l8.86133 7.59082a1.00655 1.00655 0 0 0 1.65039-.75934v-4.7802h5.46v11.18066a1.00013 1.00013 0 0 0 .34961.75928l7.63184 6.60156h-6.98148a.99974.99974 0 0 0 -1 1v3.7002a1.00019 1.00019 0 0 0 2-.00006v-2.70014h5.98145a2.03152 2.03152 0 0 0 1.32031-3.56982z"/><path d="m43.99564 33.718a13.00122 13.00122 0 0 0 .00012 26.00244c17.24786-.71391 17.24231-25.29106-.00012-26.00244zm.00012 24.00244c-14.59461-.60394-14.58984-21.40082.00006-22.00244a11.00122 11.00122 0 0 1 -.00006 22.00244z"/><path d="m49.001 45.71942h-4v-4.00049a1.00019 1.00019 0 0 0 -2 0v4.00049h-4a1.00019 1.00019 0 0 0 .00006 2h3.99994v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2z"/></svg>
                          </div>       
                          <h4 className="mb-3">Add New Address</h4>                             
                          <button className="btn btn-primary px-5" onClick={() => manageAddAddress()}>Add</button>
                      </div>
                  </div>
                </div>
              </div>
             )}
            
             
            <div className="col-xl-4 side-bar">
              <h4 className="title m-b15">Your Order</h4>
              <div className="order-detail sticky-top">
                {cart && cart.line_items && cart.line_items.map((item,index) =>
 
                  <div className="cart-item style-1" key={index}>
                    <div className="dz-media me-3 tshirtImage">
                      <img src={process.env.REACT_APP_SERVER_URL + (item.variant.variant_images[0] ? item.variant.variant_images[0].variant_image.webp.url : '')} alt="product" className='product Image'/>
                    </div>
                    <div className='dz-content checkoutPriceBox'>
                      <div className="">
                        <h6 className="title mb-0">{item.variant.product.name}</h6> 
                        <span className="price">₹{roundOff(item.price)} <del className='m-r10'>₹{roundOff(item.actual_price)}</del> </span>
                        {item.size  && (
                                  <div className="d-flex align-items-center"> 
                                    <h6 className="dz-price mb-0">Size: {item.size}  </h6>
                                </div>
                            )}
                      </div>
                      
                      <div className="product-size m-b-10">
                           ₹{roundOff(item.price)}
                         
                      </div>
                     
                    </div>
                  
                  </div>  
                )} 
                <table>
                  <tbody>
                    <tr className="subtotal">
                      <td>Subtotal</td>
                      <td className="price">₹{cartSubtotal}</td>
                    </tr>
                    <tr className="title">
                      <td><h6 className="title font-weight-500">Shipping</h6></td>
                      <td></td>
                    </tr>
                    <tr className="shipping">
                      <td>
                        <div className="custom-control custom-checkbox">
                          <label className="form-check-label" >
                            Shipping
                          </label>
                        </div>
                         
                      </td>
                      <td className="price">₹{shippingCharges}</td>
                    </tr>
                    <tr className="total">
                      <td>Total</td>
                      <td className="price">₹{cartSubtotal + shippingCharges}</td>
                      
                    </tr>
                  </tbody>
                </table>
                 
                
                {/* <p className="text">Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our <a href="javascript:void(0);">privacy policy.</a></p>
                <div className="form-group">
                  <div className="custom-control custom-checkbox d-flex m-b15">
                    <input type="checkbox" className="form-check-input" id="basic_checkbox_3"/>
                    <label className="form-check-label" >I have read and agree to the website terms and conditions </label>
                  </div>
                </div> */}
                {!isOrderPlaced && <button onClick={() => managePlaceOrder()} className="btn btn-secondary w-100">PLACE ORDER</button>}
                {isOrderPlaced && <button  className="btn btn-secondary w-100">Please Wait...</button>}
              </div>
            </div>
          </div>
        </div>
        <AddressModal formType={"New"} />
        </>
        }
        
        
      </div>
    </div> 
  );
}

export default Checkout;

 
